export default __webpack_public_path__ + "static/media/Mark-3-HUD-Flight Indicator.b743afbf.jpg";